import React from 'react';
import { Moon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-brand-navyLight text-white py-12 px-6" data-id="element-62">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-63">
        <div className="flex items-center gap-2 mb-6 text-brand-lavender" data-id="element-64">
          <Moon className="w-6 h-6 fill-current" data-id="element-65" />
          <span className="font-playfair font-bold text-xl text-white" data-id="element-66">
            El Método Sueño Profundo
          </span>
        </div>

        <p className="text-white/60 text-sm max-w-2xl mb-8 leading-relaxed" data-id="element-67">
          Descargo de responsabilidad: La información proporcionada en este
          sitio web y en el producto no pretende sustituir el consejo,
          diagnóstico o tratamiento médico profesional. Siempre busque el
          consejo de su pediatra u otro proveedor de salud calificado con
          cualquier pregunta que pueda tener sobre una condición médica de su
          bebé.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-white/80 mb-8" data-id="element-68">
          <a href="#" className="hover:text-brand-amber transition-colors" data-id="element-69">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-brand-amber transition-colors" data-id="element-70">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-brand-amber transition-colors" data-id="element-71">
            Contacto
          </a>
        </div>

        <p className="text-white/40 text-xs" data-id="element-72">
          &copy; {new Date().getFullYear()} El Método Sueño Profundo. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
};